<template>
  <div>

    <v-dialog v-model="error" width="500">

      <v-card>
        <v-card-title class="headline red accent-3" primary-title> Warning Message </v-card-title>
        <v-card-text> {{errorMsg}} </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <div v-if="isLoaded">
    <v-toolbar flat color="white">
      <v-toolbar-title></v-toolbar-title>
        <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
       <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
                <!-- project information details -->
                <project-details-info :ProjectData="editedItem"/>
                <assigned-agent-group-to-project v-if="editedItem.project_type_id === 3" :project_id=editedItem.id></assigned-agent-group-to-project>
                <assigned-teams-to-project v-if="editedItem.dasher_category_id === 2" :project_id=editedItem.id></assigned-teams-to-project>
                <v-layout row v-if="checkData">
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="project white--text">
                        <div class="headline">Project Pre Survey Questions</div>
                      </v-card-title>
                      <v-card-text>
                          <div v-for="(pre_ques,index) in editedItem.pre_question" v-bind:key="index">
                            <!-- question part -->
                            <div>
                              <span>Pre_Q{{index+1}}.</span>
                              <span v-if="editedItem.project_language ==1 || editedItem.project_language ==3">
                              <span class="font-weight-bold">Question Title English:</span> &nbsp;&nbsp;&nbsp;{{ pre_ques.question_title_en }}
                              </span>
                              <br />
                              <span v-if="editedItem.project_language ==2 || editedItem.project_language ==3">
                              &nbsp;&nbsp;&nbsp; <span class="font-weight-bold">Question Title Bangla:</span> &nbsp;&nbsp;&nbsp;{{ pre_ques.question_title_bn }} <br />
                              </span> 
                              <!-- option and multiple image section -->
                              <div v-if="pre_ques.ui_category_id ==1 || pre_ques.ui_category_id ==2 || pre_ques.ui_category_id ==4 || pre_ques.ui_category_id ==14">
                                <div v-if="pre_ques.ui_category_id ==14">
                                  <span v-for="(option, i) in (pre_ques.pre_image_options)" :key='i'>
                                    <v-img height="150" width="200" :src="indexData.dataStatus4.pre_image_op + option.url"></v-img>
                                    <a :href="indexData.dataStatus4.pre_image_op + option.url" target="_blank">download</a>
                                    <div class="mt-3"></div>
                                  </span>
                                </div>
                                <div v-else>
                                  <div v-if="editedItem.project_language ==1 || editedItem.project_language ==3">
                                    <span class="font-weight-bold">Option English:</span> <br>
                                    <span v-for="(option, i) in (pre_ques.pre_options)" :key='i'>
                                      <v-icon small>
                                      radio_button_unchecked
                                      </v-icon>
                                      {{option.title}}<br> 
                                    </span>
                                  </div>
                                  <div v-if="editedItem.project_language ==2 || editedItem.project_language ==3">
                                    <br> <span class="font-weight-bold">Option Bangla:</span> <br>
                                    <span v-for="(option, i) in (ques.pre_bangla_options)" :key='i'>
                                      <v-icon small>
                                      radio_button_unchecked
                                      </v-icon>
                                      {{option.title}}<br> 
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <!-- instruction and description -->
                              <div>
                                <span
                                  v-if="pre_ques.pre_instruction != null && (editedItem.project_language ==1 || editedItem.project_language ==3)">
                                <span class="font-weight-bold"> Instruction:
                                  </span> <br />
                                  &nbsp;&nbsp;&nbsp;<div v-html="ques.instruction.instruction"></div>
                                </span>
                                <span
                                  v-if="pre_ques.pre_instruction_bangla != null && (editedItem.project_language ==2 || editedItem.project_language ==3)">
                                <span class="font-weight-bold"> Instruction Bangla:
                                  </span> <br />
                                  &nbsp;&nbsp;&nbsp;<div v-html="ques.pre_instruction_bangla.instruction_bangla"></div>
                                </span>

                                <span
                                  v-if="pre_ques.pre_description != null && (editedItem.project_language ==1 || editedItem.project_language ==3)">
                                <span class="font-weight-bold"> Description:
                                  </span> <br />
                                  &nbsp;&nbsp;&nbsp;<div v-html="pre_ques.pre_description.description"></div>
                                </span>
                                <span
                                  v-if="pre_ques.pre_description_bangla != null && (editedItem.project_language ==2 || editedItem.project_language ==3)">
                                <span class="font-weight-bold"> Description Bangla:
                                  </span> <br />
                                  &nbsp;&nbsp;&nbsp;<div v-html="pre_ques.pre_description_bangla.description_bangla"></div>
                                </span>
                              </div>
                            </div>
                            <div>
                              <pre-survey-question-logic :pre_question_logic="pre_ques.pre_question_logic" :operators="indexData.operators"/>
                            </div>
                          </div>
                        <!-- end question section -->
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>  
                <!-- pre survey question end -->              
                <v-layout row>
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="project white--text">
                        <div class="headline">Project Questions</div>
                      </v-card-title>
                      <v-card-text>
                        <!-- start question section -->
                        <span class="font-weight-bold">Note:Here star mark (<span class="red--text">*</span>) is required.</span>
                        <br>
                        <div 
                        v-for="(ques,index) in editedItem.question"
                        v-bind:key="index"
                        >
                          <!-- question part -->
                          <div>
                            <span>{{index+1}}.</span>
                              <span v-if="editedItem.project_language ==1 || editedItem.project_language ==3">
                              <span class="font-weight-bold">Question Title English:</span> &nbsp;&nbsp;&nbsp;{{ ques.question }}
                                <span class="red--text headline" v-if="ques.required_optional == 1">
                                  *
                                </span>
                              </span>
                              <br />
                              <span v-if="editedItem.project_language ==2 || editedItem.project_language ==3">
                              &nbsp;&nbsp;&nbsp; <span class="font-weight-bold">Question Title Bangla:</span> &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }} <br />
                                <span class="red--text headline" v-if="ques.required_optional == 1">
                                  *
                                </span>
                              </span> 
                              <div v-if="ques.ui_category_id == 15">
                                <span v-if="ques.contact_info.first_name == '1'">
                                    First Name: _________
                                </span>
                                <span v-if="ques.contact_info.middle_name == '1'">
                                  <br />  Middle Name: _________
                                </span>
                                <span v-if="ques.contact_info.last_name == '1'">
                                  <br />  Last Name: _________
                                </span>
                                <span v-if="ques.contact_info.phone == '1'">
                                  <br />
                                  <v-icon small>
                                    call </v-icon>Phone: _________
                                </span>
                                <span v-if="ques.contact_info.email == '1'">
                                  <br />email: _________
                                </span>
                                <span v-if="ques.contact_info.address == '1'">
                                  <br /><v-icon small>
                                    home </v-icon><span class="font-weight-bold"> Address:</span>
                                  <br />Country: _________ <br />Division: _________
                                  <br />District : _________ <br />Area: _________
                                  <br />Road No: _________ <br />House No: _________
                                </span>
                              </div>
                              <!-- option and multiple image section -->
                              <div v-if="ques.ui_category_id ==1 || ques.ui_category_id ==2 || ques.ui_category_id ==4 || ques.ui_category_id ==14">
                                  <div v-if="ques.image_options && ques.ui_category_id ==14">
                                    <span v-for="(option, i) in (ques.image_options)" :key='i'>
                                      <v-img height="150" width="200" :src="indexData.dataStatus4.image_op + option.url"></v-img>
                                      <a :href="indexData.dataStatus4.image_op + option.url" target="_blank">download</a>
                                      <div class="mt-3"></div>
                                    </span>
                                  </div>
                                  <div v-else>
                                    <div v-if="ques.options && (editedItem.project_language ==1 || editedItem.project_language ==3)">
                                      <span class="font-weight-bold">Option English:</span> <br>
                                      <span v-for="(option, i) in (ques.options)" :key='i'>
                                        <v-icon small>
                                        radio_button_unchecked
                                        </v-icon>
                                        {{option.title}}<br> 
                                      </span>
                                    </div>
                                    <div v-if="ques.bangla_options && (editedItem.project_language ==2 || editedItem.project_language ==3)">
                                      <br> <span class="font-weight-bold">Option Bangla:</span> <br>
                                      <span v-for="(option, i) in (ques.bangla_options)" :key='i'>
                                        <v-icon small>
                                        radio_button_unchecked
                                        </v-icon>
                                        {{option.title}}<br> 
                                      </span>
                                    </div>
                                  </div>
                              </div>
                              <!-- instruction and description -->
                              <div>
                                <span
                                  v-if="ques.instruction != null && (editedItem.project_language ==1 || editedItem.project_language ==3)">
                                <span class="font-weight-bold"> Instruction:</span> &nbsp;&nbsp;&nbsp;<div v-html="parseDataToJson(ques.instruction.instruction)"></div>
                                </span>
                                <span
                                  v-if="ques.instruction_bangla != null && (editedItem.project_language ==2 || editedItem.project_language ==3)">
                                <span class="font-weight-bold"> Instruction Bangla:</span>  &nbsp;&nbsp;&nbsp;<div v-html="parseDataToJson(ques.instruction_bangla.instruction_bangla)"></div>
                                </span>

                                <span
                                  v-if="ques.description != null && (editedItem.project_language ==1 || editedItem.project_language ==3)">
                                <span class="font-weight-bold"> Description:</span>&nbsp;&nbsp;&nbsp;<div v-html="parseDataToJson(ques.description.description)"></div>
                                </span>
                                <span
                                  v-if="ques.description_bangla != null && (editedItem.project_language ==2 || editedItem.project_language ==3)">
                                <span class="font-weight-bold"> Description Bangla:</span>&nbsp;&nbsp;&nbsp;<div v-html="parseDataToJson(ques.description_bangla.description_bangla)"></div>
                                </span>
                              </div>
                              <!-- multiple answer -->
                              <div v-if="ques.ui_category_id ==2">
                                <span class="font-weight-bold">Multiple ans:</span>
                                <v-icon small class="mr-1">check_box_outline_blank</v-icon>
                                <span v-if="ques.multiple_answer ==1">yes</span>
                                <span v-else>no</span>
                              </div>
                              <!-- range slider star rating -->  
                              <div v-if="ques.ui_category_id ==6 || ques.ui_category_id ==7 || ques.ui_category_id ==8">
                                <span 
                                class="font-weight-bold"
                                v-if="ques.option_val !=null && ques.option_val !=null">
                                Min value:{{ques.option_val.min_value}}<br>
                                Max value:{{ques.option_val.max_value}}
                                </span>
                                <span 
                                class="font-weight-bold"
                                v-if="ques.option_val !=null">
                                <br>
                                interval:{{ques.option_val.interval}}
                                </span> 
                              </div>
                            </div>
                          <!-- edn question part -->
                          <!-- question logic block -->
                            <div v-if="ques.has_logic">
                              <question-logic :question_logic="parseDataToJson(ques.question_logic.question_logic)" :questions="editedItem.question" :counter_index="index"/>
                            </div>
                        </div>

                      </v-card-text>

                    </v-card>

                  </v-flex>

                </v-layout> 
              </v-container>
            </v-flex>

         </v-layout>
            
        <!-- <v-divider inset></v-divider> -->
        <v-container fluid>
          <v-layout row>
            <div>
              <v-btn color="red" @click="close">Cancel</v-btn>
            </div>
          </v-layout>
        </v-container>
        </template>
    </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
     <div v-if="alertMsg">
        <v-alert v-if="error == 0 && statusCode == 200" :value="true" type="success" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 204" :value="true" type="info" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && (statusCode == 403 || statusCode == 400)" :value="true" type="warning" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 500" :value="true" type="error" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
     </div>
     <div v-if="indexData.dataStatus4.total < 0" class="text-xs-center">
       <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>

     </div>
    <v-data-table
      :headers="headers"
      :items="indexData.dataStatus4.data"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :loading="loading"
      class="elevation-1"
    >
     <v-progress-linear color="blue" indeterminate></v-progress-linear>
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ props.header.text }}
            </span>
          </template>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
     
      <template v-if="indexData.dataStatus4.total > 0" v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.project_type_name }}</td>
        <td>{{ props.item.begin_date }}</td>
        <td>{{ props.item.end_date }}</td>
        <td>{{ props.item.total_budget_amount }}</td>
        <td>{{ props.item.per_survey_cost }}</td>
        <td>{{ props.item.number_of_response }}</td>
        <td class="justify-center layout px-1">
          <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2" v-on="on" @click="checkItem(props.item)">
                    visibility
                </v-icon>
              </template>
            <span>view</span>
          </v-tooltip>
        </td>
      </template>
      <template v-else v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">
          {{ errorMsg }}
        </v-alert>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template v-slot:pageText>
        Rows {{ indexData.dataStatus4.from }} - {{ indexData.dataStatus4.to }} of {{ indexData.dataStatus4.total }}
      </template>
    </v-data-table>
    <template>
      <div class="text-xs-center">
        <v-pagination
          v-model="indexData.dataStatus4.current_page"
          :length="indexData.dataStatus4.last_page"
          @input="onPageChange"
        ></v-pagination>
      </div>
    </template>
  </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { ProjectDetailsInfo, QuestionLogic, PreSurveyQuestionLogic, AssignedAgentGroupToProject, AssignedTeamsToProject } from "@/components/index";
  export default {
    components:{
      ProjectDetailsInfo,
      QuestionLogic,
      PreSurveyQuestionLogic,
      AssignedAgentGroupToProject,
      AssignedTeamsToProject,
    },
    data: () => ({
      dialog: false,
      alertMsg: false,
      // apiUrl: 'change-status',
      routePath: '/pending',
      
      sl: 1,
      headers: [
        { text: 'Project Id', align: 'left', value: 'id' },
        { text: 'Project Title', align: 'left', value: 'name' },
        { text: 'Project Type', value: 'project_type_id' },
        { text: 'Project Starting Time', value: 'begin_date' },
        { text: 'Project Ending Time', value: 'end_date' },
        { text: 'Total Budget', value: 'total_budget_amount' },
        { text: 'Per Survey Cost', value: 'per_survey_cost' },
        { text: 'Total Response', value: 'number_of_response' },
        { text: 'Actions', align: 'center', value: 'name', sortable: false }
      ],
      loading: false,
      search: '',
      pagination: {},
      rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
      editedIndex: -1,  
      editedItem: { 
        project_types:{
          name:''
        }
        
      },
      defaultItem: {
        
      },
    }),
    
    computed: {
      ...mapGetters(['indexData', 'error', 'statusCode', 'errorMsg']),
      isLoaded() {
        if (this.indexData.dataStatus4) {
          return true;
        } else {
          return false;
        }
      },
      checkData(){
        if(this.editedItem){
          if(this.editedItem.has_pre_survey){
            return 1;
          }else{
            return 0;
          }
        }
        return 0;
      }, 
    },

    watch: {
      pagination() {
            this.paginationMethod()
      },
      dialog (val) {
        val || this.close()
      }
    },

    // created () {
    //   // this.initialize('indexData.dataStatus4')
    // },

    methods: {
       initialize () {
         this.paginationMethod()
       
        // this.alertMsg = true
        // setTimeout(() => {
        //   this.alertMsg = false
        // }, 300)
      },
      parseDataToJson(value){
        if(value != undefined){
          return JSON.parse(value);
        }
        return "";
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      checkItem (item) {
        if (this.indexData.dataStatus4.data) {
        // console.log(item)
        this.editedIndex = this.indexData.dataStatus4.data.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      onPageChange(){
        this.paginationMethod()
      },
      getProjectLanguage(project_language){
        if(project_language==1){
          return "English"
        }else if(project_language==2){
          return "Bangla"
        }else{
          return "English & Bangla both"
        }
      },
      paginationMethod() {
        this.loading = true
        if (this.indexData.dataStatus4.data) {
        if(this.search){
          this.$store.dispatch('changeProjectStatus', ['status-list', 4, this.search, this.indexData.dataStatus4.current_page, this.pagination.rowsPerPage])
          this.loading = (this.indexData.dataStatus4.data) ? false : true
            this.alertMsg = true
            setTimeout(() => {
              this.alertMsg = false
            }, 300)
        }else{
          this.$store.dispatch('changeProjectStatus', ['status-list', 4, this.search, this.indexData.dataStatus4.current_page, this.pagination.rowsPerPage])
          this.loading = (! this.indexData.dataStatus4.error) ? false : true
            this.alertMsg = true
            setTimeout(() => {
              this.alertMsg = false
            }, 300)
        }
        }
      },
    }
  }
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
  .project {
    background: #ff2e2e;
  }
</style>